import gql from 'graphql-tag';
import { convertFilterRequestUrl } from 'utils/utils';

export default ({ page, size, filter, sort }) => {
  const sortStr = sort ? `, sort: ${sort}` : '';
  const filterStr = filter
    ? `, filter: ${convertFilterRequestUrl(filter, ['status'])}`
    : '';
  const searchExpenseData = `searchExpenseData(page: ${page}, size: ${size}${sortStr}${filterStr})`;
  return gql`
    query {
      ${searchExpenseData} {
        id
        startDate
        expensePeriodUnit
        splitEvenly
        fixedExpenseData {
          index
          type
          amount
        }
        variableExpenseData {
          index
          type
          amount
        }
      }
    }
  `;
};
